var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.typeWarning)?_c('div',{staticClass:"infoArea"},[_c('base-icon',{staticClass:"icon",attrs:{"name":"info"}}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.infoText))])],1):_c('div',{staticClass:"infoArea yellow"},[_c('base-icon',{staticClass:"icon",attrs:{"name":"warn-yellow"}}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.infoText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }